/* eslint-disable */
const projectDetails = [
  {
    name: "Birthday Reminder",
    link: "https://birthday-reminder-tushar.netlify.app/"
  },
  { name: "Tours", link: "https://tours-app-tushar.netlify.app/" },
  { name: "Reviews", link: "https://reviews-tushar.netlify.app/" },
  { name: "Accordion", link: "https://accordion-tushar-app.netlify.app/" },
  { name: "Menus", link: "https://menus-app-tushar.netlify.app/" },
  { name: "Tabs", link: "https://tabs-app-tushar.netlify.app/" },
  { name: "Slider", link: "https://slider-app-tushar.netlify.app/" },
  {
    name: "Lorem Ipsum generator",
    link: "https://lorem-ipsum-gen-app-tushar.netlify.app/"
  },
  {
    name: "Color Generator",
    link: "https://color-gen-app-tushar.netlify.app/"
  },
  { name: "Grocery Bud", link: "https://grocery-bud-app-tushar.netlify.app/" },
  { name: "Navbar", link: "https://navbar-app-tushar.netlify.app/" },
  { name: "Sidebar", link: "https://sidebar-app-tushar.netlify.app/" },
  { name: "Stripe", link: "https://stripe-app-tushar.netlify.app/" },
  { name: "Cart", link: "https://shopping-cart-app-tushar.netlify.app/" },
  {
    name: "MarkDown Preview",
    link: "https://markdown-app-tushar.netlify.app/"
  },
  {
    name: "Random Person",
    link: "https://random-person-app-tushar.netlify.app/"
  },
  { name: "Pagination", link: "https://pagination-app-tushar.netlify.app/" },
  { name: "Infinite Scroll", link: "https://infinityy-scrolll.netlify.app/" },
  { name: "Dark Mode", link: "https://dark-mode-app-tushar.netlify.app/" },
  { name: "Movie Database", link: "https://movie-db-app-tushar.netlify.app/" }
];
export default projectDetails;



// WEBPACK FOOTER //
// ./src/assets/data.js